import { useTranslation as unifiedUseTranslation } from '@aviv-unified-frontend/runtime/i18n';
export const plural = (key, count) => {
    if (count === 0)
        return `${key}.zero`;
    if (count === 1)
        return `${key}.one`;
    return `${key}.other`;
};
//TODO : need to add nutzungsdauer in shell tag
export const useTranslation = (namespace = 'nutzungsdauer') => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const unifiedTranslationfn = unifiedUseTranslation(`app_${namespace}`);
    const t = unifiedTranslationfn.t;
    const tPlural = (key, count) => t(plural(key, count), { count });
    return { t, tPlural };
};
